import { render, staticRenderFns } from "./ProgramActivityReminderCreateDetail.vue?vue&type=template&id=1247ed52"
import script from "./ProgramActivityReminderCreateDetail.vue?vue&type=script&lang=js"
export * from "./ProgramActivityReminderCreateDetail.vue?vue&type=script&lang=js"
import style0 from "./ProgramActivityReminderCreateDetail.vue?vue&type=style&index=0&id=1247ed52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports